// extracted by mini-css-extract-plugin
export default {"root":"_1xwEl","disabled":"_3hQJn","black":"_3s6wE","greyDarkFull":"_3bKFW","red":"_3qc0f","redFull":"_1o7r2","greyFull":"_100KT","primary":"_3E6Nj","yellowFull":"_1dIwY"};